/* eslint-disable react-refresh/only-export-components */
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface MobileFilterContextValue {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
}

const MobileFilterContext = createContext<MobileFilterContextValue | undefined>(
  undefined
);

export interface MobileFilterProviderProps {
  children: ReactNode;
}

export function MobileFilterProvider({ children }: MobileFilterProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {
    isOpen,
    toggle,
    close,
  };

  return (
    <MobileFilterContext.Provider value={value}>
      {children}
    </MobileFilterContext.Provider>
  );
}

// Hook can be in same file since it's tightly coupled to the context
export function useMobileFilter() {
  const context = useContext(MobileFilterContext);

  if (context === undefined) {
    throw new Error(
      'useMobileFilter must be used within a MobileFilterProvider'
    );
  }

  return context;
}
